/**=========================================================
 * Module: offers.js
 * Offers Controller
 =========================================================*/

App.controller('OffersController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService','ngDialog',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog) {
    "use strict";

    $scope.type = 'offer';
    $scope.filter = 'sum=true&_mode=list';

    $scope.data = [];

    $scope.openOfferDetails = function(offer){
    	if(offer.total){
	    	offer.loadingDetails = true;
	    	var scope = $scope.$new();
	    	scope.offer = offer;
	    	D.query('offer', 'project='+offer.project+'&supplier='+offer.supplier+'&sum=false').then(
	                function(response){
	                	offer.loadingDetails = false;
	                	offer.offers = response;
                        offer.totalOfferBeforeDiscount = offer.offers.reduce((prev, curr) => prev + curr.total, 0)
	                	ngDialog.open({
	                	      template: '/app/views/entities/offer-details.html',
	                	      className: 'ngdialog-theme-default ngdialog-theme-large',
	                	      scope: scope,
	                	      cache: false
	                	    })
	                }
	            ).catch(console.error);
    	}
    };

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

        if($rootScope.user.id){
            $scope.initialized = true;

            var title = 'labels.OFFERS';
            if($rootScope.user.groupType=='SUPPLIER')
            	title = 'labels.OFFERSSENT';
            if($rootScope.user.groupType=='CLIENT')
            	title = 'labels.OFFERSRECEIVED';

            $scope.page = {
                    title: title,
                    subTitle: ''
                };

            $scope.table = {
                type: 'offer',
                title: '',
                filter: true,
                cls: 'no-panel-table',
				containerStyle: {'min-height': '300px'},
                includedFields: ['project','currency','supplier',
                    'discount',
                    'totalOfferBeforeDiscount',
                    'total',
                    'service',
                    'serviceDiscount',
                    'createdOn',
                    'projectOwner',
                    'proposedDate',
                    'notes',
                    'offers'],
                fields: [
                    {
                    	available: false,
                    	name: 'createdOn',
                    	type: 'date',
                        filterType: 'date',
                        filterValue: '',
                        orderable: true
                    },{
                    	available: true,
                    	name: 'projectCode',
                        filterType: 'text',
                        filterValue: '',
                        orderable: true,
                        compareType: 'projectCode',
                        hasLink: $rootScope.user.groupType!='SUPPLIER' ? true : false,
						style: {
							'white-space': 'nowrap'
						}
                    },{
                    	available: true,
                    	name: 'projectName',
                        filterType: 'text',
                        filterValue: '',
                        hasLink: $rootScope.user.groupType=='SUPPLIER' ? true : false,
						style: {
							width: '400px'
						}
                    },{
                    	available: $rootScope.user.groupType!='CLIENT',
                        name: 'clientName',
                        filterType: 'clients',
                        filterValue: ''
                    },{
                    	available: $rootScope.user.admin || $rootScope.user.groupType=='CLIENT',
                        name: 'ownerName',
                        filterType: 'owners',
                        filterValue: ''
                    },{
                    	available: $rootScope.user.groupType!='SUPPLIER',
                        name: 'supplierName',
                        filterType: 'suppliers',
                        filterValue: ''
                    },{
                    	available: true,
                        name: 'source',
                        type: 'enum',
                        enumType: 'language',
                        filterType: 'language',
                        filterValue: ''
                    },{
                    	available: true,
                        name: 'destinations',
                        type: 'enumSet',
                        enumType: 'language',
                        filterType: 'multilanguage',
                        filterValue: '',
						style: {
							width: '400px'
						}
                    },{
                    	available: true,
                        name: 'total',
                        type: 'currency',
                        filterType: 'number',
                        filterValue: '',
                        orderable: true,
                        decimalSep: $rootScope.user.decimalSep,
						style: {
							'white-space': 'nowrap'
						}
                    },{
                    	available: true,
                        name: 'confirmed',
                        label: $rootScope.user.groupType=='SUPPLIER' ? 'confirmed' : 'accepted',
                        type: 'enum',
                        enumType: 'confirmedStatus',
                        filterType: 'select',
                        filterOptions: [
                                        {value:'', label:''},
                                        {value:"true", label:'enums.confirmedStatus.YES'},
                                        {value:"false", label:'enums.confirmedStatus.NO'},
                                        {value:"null", label:'enums.confirmedStatus.WAITING'}
                                        ]
                    },/*{
                    	available: $rootScope.user.groupType=='ADMIN' || $rootScope.user.groupType=='CLIENT',
                    	name: 'accepted',
                        type: 'boolean'
                    },*/{
                    	available: true,
                    	name: 'details',
                    	type: 'click',
                    	onclick: $scope.openOfferDetails,
                    	icon: 'aqi-link'
                    }
                ],
                link: {
                	state: {'SUPPLIER':'app.entity','ADMIN':'app.entity','CLIENT':'app.do'}[$rootScope.user.groupType],
                	action: {'SUPPLIER':'estimate','ADMIN':'offers','CLIENT':'open'}[$rootScope.user.groupType],
                    type: 'project',
                    filter: 'project'
                },
                loading: true
            };

            $scope.table.baseFilter = $scope.filter;
            
            $scope.table.loadCallback = function(scope){
                let newData = []
                for(var i=0; i<scope.data.length; i++){
                    scope.data[i].pdf = $rootScope.app.config.functionsUrl + '/pdf?type=offer&id=' + scope.data[i].id + '&access_token=' + $rootScope.FB.token
                    if($rootScope.user.group.type=='CLIENT'){
                            if($rootScope.user.superUser || scope.data[i].projectOwner==$rootScope.user.id){
                                newData.push(scope.data[i]);
                            }
                    } else {
                        newData.push(scope.data[i]);
                    }
                }
                scope.data = newData
            }



        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();


}]);
